
import axios from 'axios';
import router from '../router'

let myHttp =axios.create({
  headers:{
    'content-type':'application/x-www-form-urlencoded'
  }
});


/**
 *
 *
 * 拦截请求
 */
myHttp.interceptors.request.use(
  config =>{
    const token =window.localStorage.getItem('token');
    if(token){
      config.headers.authorization = token
    }
    return config
  },
  error => {
    return Promise.reject(err)
  }
)

/**
 *
 * 拦截请求的响应
 */
myHttp.interceptors.response.use(
  response =>{

    // console.log('%c 拦截响应。。。。。打印返回的token','font-size:40px');
    // console.log(response);
    // console.log('响应的：'+response.config.headers.token);
    // window.localStorage.setItem('token',response.config.headers.token);
    // console.log('存储的：：'+window.localStorage.getItem('token'));
    return response;
  },
  error => {
    if(error){
      console.log('%c 拦截错误信息：'+error.response.data.error,'font-size:40px;color:red;');
       window.localStorage.setItem('loginErrorMsg',error.response.data.error);
      router.push({path:'/loginError'});
      //  this.$route.push({path:'/loginError',params:{msg:'123'}});
      return Promise.reject(error)
    }else{
     console.log('%c 没有网络连接','font-size:20px;') ;
    }
  }
)






export default myHttp



// WEBPACK FOOTER //
// ./src/utils/http.js